import labelData from './enum'
export default () => {
  const getLabelName = (value) => {

    if (!value) {
      return
    }
    if (!Object.keys(labelData).includes(value)){
      return
    }
   return labelData[value].label
  }
  return {
    getLabelName
  }
}